import {
    ApiResultDTO,
    DocumentClient_V1,
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';

export default class DocumentService {
    private readonly _documentClient: DocumentClient_V1;

    constructor() {
        this._documentClient = new DocumentClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public DocumentUploadUrl = `${<string>process.env.VUE_APP_API_V1_URL}/document`;

    public DeleteDocument(documentUid: string) : Promise<ApiResultDTO> {
        return this._documentClient.delete(documentUid);
    }

    public OwnersManualURL(vehicleUid: string) : string {
        return `${<string>process.env.VUE_APP_API_V1_URL}/Vin/${vehicleUid}/OwnersManual`;
    }

    public ChecklistURL(checklistUid: string) : string {
        return `${<string>process.env.VUE_APP_API_V1_URL}/ConsumerInformation/${checklistUid}/Checklist`;
    }
}